import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import { useGetAgroCitiesQuery } from 'services/api/Meteorology/Agro';

export default function useLocations() {
  const { data, error } = useGetAgroCitiesQuery();

  useHandleRequestErrors(error as ResponseError);

  return { cities: data };
}
